import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

class ByteliveApi {
	static getBaseURL() {
		return (localStorage.apiDomain || config.api) + '/service/bytelive';
	}

	static getInstance() {
		const instance = axios.create({
			baseURL: this.getBaseURL(),
			headers: {
				'Content-Type': 'application/json'
			}
		});

		instance.interceptors.response.use(
			response => response,
			error => {
				if (!error.response || error.response.status === 401) {
					const event = document.createEvent("Event");
					event.initEvent("SessionExpired", true, true);
					document.dispatchEvent(event);
				}
				return Promise.reject(error);
			}
		);

		return instance;
	}
	static get(path) {
		const byteliveInstance = this.getInstance();
		byteliveInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return byteliveInstance.get(path)
			.then(function (response) {
				let data = {...response.data};
				if (data?.results) {
					data.results = response.data.results.map(user => {
						return {
							...user,
							id: user._id,
						}
					})
				}
				return data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static post(path, payload) {
		const byteliveInstance = this.getInstance();
		byteliveInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return byteliveInstance.post(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static patch(path, payload) {
		const byteliveInstance = this.getInstance();
		byteliveInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return byteliveInstance.patch(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static delete(path, payload) {
		const byteliveInstance = this.getInstance();
		byteliveInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return byteliveInstance.delete(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
}

export default ByteliveApi;
